module.exports = __webpack_public_path__ + "img/convert-to-case-active.bd724563.svg";